import { render, staticRenderFns } from "./TestBegin.vue?vue&type=template&id=4c8bc550&scoped=true"
import script from "./TestBegin.vue?vue&type=script&lang=js"
export * from "./TestBegin.vue?vue&type=script&lang=js"
import style0 from "./TestBegin.vue?vue&type=style&index=0&id=4c8bc550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8bc550",
  null
  
)

export default component.exports